import React from 'react';
import convert1 from '../../assets/work/conver.png';
import { BsFillArrowRightCircleFill } from 'react-icons/bs';
import convert2 from '../../assets/work/converCC.png';

const Convert = () => {
    return (
        <div className="bg-[#0a192f] mx-auto min-h-screen md:pt-44 pt-40">
      <h2 className="mb-12 flex justify-center md:text-5xl text-xl p-6 bg-stone-600 text-orange-500">
        Doctor portal project details
      </h2>
      <div className="flex justify-center">
        <div className="text-5xl  md:max-w-4xl">
          <div className=" card card-compact max-w-full bg-base-100 shadow-xl mb-8">
            <figure>
              <img src={convert1} alt="Convert Homepage" />
            </figure>
            <div className="card-body">
              <h2 className="card-title text-3xl text-orange-600 underline-offset-8 underline">
                Home Page UI
              </h2>
              <p className="text-xl font-medium mb-3">
                <BsFillArrowRightCircleFill className="mr-2 text-orange-600 inline-block text-2xl" />
                This website serves as a numbers-to-words converter.
              </p>
              <p className="text-xl font-medium mb-3">
                <BsFillArrowRightCircleFill className="mr-2 text-orange-600 inline-block text-2xl" />
                This page features a lovely user interface with a neon atmosphere.
              </p>
              <p className="text-xl font-medium mb-3">
                <BsFillArrowRightCircleFill className="mr-2 text-orange-600 inline-block text-2xl" />
                Any number value can be entered on this page, and after clicking Convert, the result will appear as text.
              </p>
            </div>
          </div>
          <div className=" card card-compact max-w-full bg-base-100 shadow-xl mb-8">
            <figure>
              <img src={convert2} alt="convert " />
            </figure>
            <div className="card-body">
              <h2 className="card-title text-3xl text-orange-600 underline-offset-8 underline">
                Result
              </h2>
              <p className="text-xl font-medium mb-3">
                <BsFillArrowRightCircleFill className="mr-2 text-orange-600 inline-block text-2xl" />
                This website's outcome state page is this one.
              </p>
              <p className="text-xl font-medium mb-3">
                <BsFillArrowRightCircleFill className="mr-2 text-orange-600 inline-block text-2xl" />
                Results are displayed in text at the bottom of the page.
              </p>
              <p className="text-xl font-medium mb-3">
                <BsFillArrowRightCircleFill className="mr-2 text-orange-600 inline-block text-2xl" />
                On this page, the button and text have a glowing glowing effect.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    );
};

export default Convert;